<template>
  <div>
    <div
      class="play-icon"
    />
    <div
      class="play-event"
      @click="showTrailer"
    >
      <p>Play Event Trailer</p>
    </div>
    <md-dialog
      :md-active.sync="showDialog"
      class="kabs-dailog"
    >
      <div class="md-layout kab-dialog-container">
        <youtube
          class="md-layout md-gutter video-preview"
          :video-id="videoId"
        />
      </div>
      <md-dialog-actions
        class="close-icon"
      >
        <i
          class="material-icons md-size-2x"
          @click="closeDialog"
        >
          clear
        </i>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
export default {
  name: "KabTrailer",
  data () {
    return {
      videoId: 'K1_-IQ60CJU',
      showDialog: false
    }
  },
  methods: {
    showTrailer() {
      this.showDialog = true
    },
    closeDialog() {
      this.showDialog = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.play-icon {
  cursor: pointer;
  margin-top: 0px;
}
.play-event {
  p {
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}
@media only screen and (max-width: 600px) {
  .play-icon {
    margin-top: 20px;
  }
}

@media only screen and (max-width: 832px) and (orientation: landscape) {
  .play-icon {
    margin-top: 20px;
  }
}

@media only screen and (max-width: 1024px) and (orientation: landscape) {
  .play-icon {
    margin-top: -20px;
  }
}

@media only screen and (min-width: 1280px) and (max-width: 1366px) {
  .play-icon {
    margin-top: -20px;
  }
}
</style>
